/**
 * @module
 * @author Bayu Dwiyan Satria
 * @since 1.0.0
 */

/**
 * Libraries
 */
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Compose Tailwind class names, resolving conflicts in favour of the last one.
 *
 * @remarks
 * Plain string concatenation does not work with utility classes. `'px-2' + ' ' + 'px-4'` leaves
 * both in the attribute and the winner is decided by their order in the generated stylesheet, not
 * by the order they were written — so a component's `class` prop silently fails to override its
 * default about half the time. `twMerge` resolves same-property utilities properly; `clsx` handles
 * the conditional forms.
 *
 * @param inputs - Class values: strings, arrays, or condition objects.
 * @returns A merged class string.
 *
 * @example
 * ```ts
 * cn('px-2 py-1', 'px-4')                 // 'py-1 px-4'
 * cn('rounded', { 'opacity-50': disabled })
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
